import {
  getWelcomeNotificationConfig,
  setWelcomeNotificationConfig,
} from '@/lib/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTenant } from './use-tenant';
import { WelcomeNotificationDto } from '@/lib/dtos';

export function useGetWelcomeNotification() {
  const tenant = useTenant();

  return useQuery<WelcomeNotificationDto | null, Error>({
    queryKey: ['welcome-notification', tenant.slug],
    queryFn: () => {
      if (!tenant.slug) {
        return Promise.reject(new Error('Tenant slug is not available'));
      }
      return getWelcomeNotificationConfig(tenant.slug);
    },
    enabled: !!tenant.slug,
  });
}

export function useSetWelcomeNotification() {
  const tenant = useTenant();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: WelcomeNotificationDto) => {
      if (!tenant.slug) {
        return Promise.reject(new Error('Tenant slug is not available'));
      }
      return setWelcomeNotificationConfig(tenant.slug, payload);
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['welcome-notification', tenant.slug],
      }),
  });
}
